export default "__VITE_ASSET__DTZMFCWU__"